export default {
  common: {
    brand: 'DumpDeck',
    export: '导出',
    startAnalysis: '开始分析 →',
    analyze: '分析',
    backToLanding: '返回首页',
    dropAFile: '拖入文件',
    parsing: '解析中',
    networkOk: 'Network: {count} 个请求',
    verifyF12: 'F12 → Network 验证',
    f12Verify: 'F12 验证',
  },
  landing: {
    tagline: 'JVM Diagnostics Studio — your logs never leave your browser',
    sub: '拖入 jstack / jcmd Thread.print 输出文件（或粘贴文本），30 秒看到死锁检测、锁竞争、堆栈归组。',
    dropHere: '拖入 thread dump / GC log 到此处',
    orClick: '或点击选择文件 · 支持多文件',
    fileName: '文件名',
    pasteToFile: '粘贴为文件',
    pastePlaceholder: '或在此粘贴 jstack / GC log 文本 (Cmd+V)',
    loadedFiles: '已加载文件（{count}）',
    features: {
      privacy: '数据不离浏览器 — F12 可验证',
      perf: '后台解析，100MB+ 文件不卡 UI',
      free: '无上传、无账号 — 免费分析',
    },
  },
  thread: {
    tabs: {
      overview: '概览',
      deadlock: '死锁',
      contention: '锁竞争',
      groups: '堆栈归组',
      search: '搜索',
    },
    summary: {
      threads: '线程',
      daemon: 'daemon',
      deadlocks: '死锁',
      antiPatterns: '反模式',
      noIssues: '✓ 未发现关键问题',
      expandAll: '展开全部 {count} 条',
      collapse: '收起',
      deadlockCycle: '{count} 个死锁环',
    },
    deadlock: {
      none: '✓ 未检测到死锁。',
      cycle: '环 {n} — {count} 个线程',
    },
    contention: {
      none: '✓ 未检测到锁竞争。',
      address: '锁地址',
      holder: '持有者',
      waiters: '等待者',
      count: '数量',
      more: '+{count} 更多',
    },
    groups: {
      none: '无同堆栈分组（每个线程堆栈哈希唯一，或所有堆栈为空）。',
    },
    search: {
      allStates: '所有状态',
      namePlaceholder: '线程名包含...',
      stackPlaceholder: '堆栈包含 (类/方法)...',
      lockPlaceholder: '锁地址 0x...',
      clear: '清空',
      resultCount: '{filtered} / {total} 个线程',
      clickHint: '点击线程查看详情',
    },
    detail: {
      stack: '堆栈（{count} 帧）',
      locked: '持有锁',
      waitingToLock: '等待锁',
      parkingFor: '挂起等待',
    },
    antiPatterns: {
      none: '✓ 未检测到反模式。',
    },
    empty: '未加载 thread dump。',
    parseError: '解析错误：{error}',
    parsing: '解析 thread dump 中',
  },
  gc: {
    tabs: {
      metrics: '指标',
      timeline: '停顿时间线',
      heap: '堆曲线',
      causes: '原因归因',
      tuning: '调优建议',
    },
    summary: {
      events: '事件',
      young: 'Young',
      full: 'Full',
      throughput: '吞吐量',
      avg: '平均',
      p99: 'P99',
      max: '最大',
      freq: '频率',
      healthy: 'GC 健康',
      verdictMax: '最大停顿 {ms}ms 过长',
      verdictThroughput: '吞吐量 {pct}% 偏低',
      verdictFullGc: '{count} 次 Full GC',
    },
    timeline: {
      title: '停顿时间线',
      hint: '每次 GC 一个点，颜色按触发原因，点大小按停顿时长。鼠标悬停看详情。底部可拖动缩放。',
    },
    heap: {
      title: '堆内存曲线',
      hint: '每次 GC 前后堆使用量 + 总容量（虚线）。Metaspace 用紫线（右 Y 轴）。',
    },
    causes: {
      title: '触发原因分布',
      hint: '饼图按 cause 统计。右侧图例可点击切换显示。',
      fullGcDetail: '异常停顿 / Full GC 详情',
    },
    tuning: {
      none: '✓ 无调优建议触发。GC 行为在健康范围内。',
      recommendation: '建议',
      evidence: '证据',
      evidenceCount: '{count} 个事件',
    },
    empty: '未加载 GC log。',
    parseError: '解析错误：{error}',
    parsing: '解析 GC log 中',
  },
  multi: {
    title: 'Thread 对比 · {count} 个文件',
    introTitle: '对比说明',
    intro: '对比多个 thread dump，按线程名 join，找出跨 dump 状态变化和堆栈不变的线程。可用于定位 CPU 烧线程（多次抓取都是 RUNNABLE 且堆栈相同）和持续阻塞的线程。',
    cpuBurner: '🔥 CPU 烧线程 = 所有 dump 都 RUNNABLE 且堆栈哈希不变',
    persistentBlocked: '⛔ 持续阻塞 = 所有 dump 都 BLOCKED 且堆栈哈希不变',
    loadedFiles: '已加载文件（点击查看单文件分析）',
    dump: 'Dump {n}',
    needTwo: '需要至少 2 个 thread dump 才能对比，当前有 {count} 个。',
    dropMore: '拖入更多文件',
    parsing: '正在解析 {count} 个 dump...',
    kpis: {
      dumps: '对比 dump 数',
      cpuBurners: 'CPU 烧线程',
      persistentlyBlocked: '持续阻塞',
      newThreads: '新增线程',
      disappeared: '消失线程',
    },
    matrix: {
      title: '状态转移矩阵（按线程）',
      thread: '线程',
      cpu: 'CPU 烧?',
      stuck: '持续阻塞?',
    },
    cpuBurnerList: 'CPU 烧线程（所有 dump 都 RUNNABLE，堆栈相同）',
    persistentlyBlockedList: '持续阻塞（所有 dump 都 BLOCKED，堆栈相同）',
  },
  batch: {
    title: '批量分析 · {count} 个文件',
    threadSection: 'Thread Dump',
    gcSection: 'GC Log',
    paywallTitle: '批量分析是 Pro 功能',
    paywallBody:
      '免费用户最多可同时分析 2 个文件（同类型 thread dump 仍可用多 dump 对比）。升级到 Pro 即可无限批量分析（最多 20 个文件，任意混合）。',
    upgrade: '升级到 Pro',
    activate: '激活 Pro',
    needTwo: '至少需要 2 个文件才能批量分析，当前有 {count} 个。',
    parsing: '正在解析 {count} 个文件...',
    clickHint: '点击任意行可下钻到该文件的完整分析视图。',
    maxWarn: '已加载超过 {max} 个文件 — 仅分析前 {max} 个。',
    cols: {
      file: '文件',
      threads: '线程数',
      deadlocks: '死锁',
      antiPatterns: '反模式',
      topHotspot: '锁热点',
      events: '事件数',
      throughput: '吞吐量',
      maxPause: '最大停顿',
      fullGc: 'Full GC',
      tuningRules: '调优规则',
    },
    batchBtn: '批量分析 ({count} 个文件) →',
  },
  session: {
    title: '最近会话（Pro）',
    clear: '清空全部',
    saved: '分析已保存到本地会话（Pro）',
  },
  tuningRules: {
    title: '自定义调优规则',
    paywallTitle: '自定义调优规则是 Pro 功能',
    paywallBody:
      '免费用户使用内置 30 条规则及默认阈值。升级 Pro 后可自定义每条规则的阈值与严重程度，关闭不需要的规则。',
    upgrade: 'Upgrade to Pro',
    activate: 'Activate Pro',
    resetAll: '重置全部',
    resetAllConfirm: '清空所有自定义阈值？此操作不可撤销。',
    dirtyConfirm: '当前表单有未保存改动，丢弃？',
    list: {
      title: '规则（{count}）',
      modified: '已修改',
      disabled: '已禁用',
      thresholdSummary: '{value}（默认 {default}）',
      noThreshold: '无阈值',
    },
    form: {
      enabled: '启用此规则',
      threshold: '阈值',
      thresholdDefault: '默认: {value}{unit}',
      thresholdLessThan: '小于此值触发',
      severity: '严重程度',
      severityInfo: 'Info',
      severityWarn: 'Warn',
      severityCritical: 'Critical',
      save: '保存',
      reset: '恢复默认',
      cancel: '取消',
    },
    nav: {
      settingsButton: '⚙ 自定义规则',
    },
  },
  feedback: {
    title: '提交反馈',
    intro:
      '发现 bug？想要新功能？想分享你怎么用 DumpDeck？写在这儿——我会逐条看。',
    privacyNote:
      '你的文字和截图会发到我们服务器，记为私有工单。零追踪、零第三方分析。',
    message: '内容',
    placeholder: '描述发生了什么、你期望什么、或你想看到什么...',
    addImages: '添加截图',
    orDrop: '或从剪贴板粘贴 (Cmd+V) / 拖拽到这里',
    removeImage: '移除',
    submit: '提交反馈',
    submitting: '提交中...',
    success: '反馈已提交，谢谢！',
    openIssue: '在 GitHub 打开 →',
    nav: {
      feedbackButton: '反馈',
    },
    errors: {
      generic: '提交失败',
      network: '网络错误',
      tooManyImages: '图片太多（最多 {max} 张）',
      imageTooLarge: '图片 {name} 太大（最大 {max}）',
    },
  },
  upgrade: {
    title: '升级到 Pro',
    button: 'Upgrade to Pro',
    modalHint: '沙箱测试模式——用卡号 4242 4242 4242 4242，任意未来日期，任意 CVC。',
    priceDisclaimer: '显示价格仅供参考。最终价格和币种以 Paddle 结算页为准。',
  },
  footer: {
    tagline: '浏览器本地 JVM 诊断。数据永不出浏览器。',
    terms: '服务条款',
    refundPolicy: '退款政策',
    privacy: '隐私',
    support: '客服',
    manageSubscription: '管理订阅',
    activate: '激活 Pro',
    builtBy: '由 ZH Studio 出品 ·',
  },
  refundPolicy: {
    title: '取消订阅与退款',
    cancelTitle: '取消订阅',
    cancelBody: '通过客户门户随时取消——停止未来续费，保留 Pro 权限直到本计费周期结束。',
    cancelCta: '打开客户门户',
    refundTitle: '申请退款',
    refundBody: '退款通过 Paddle 处理。打开客户门户申请退款，或通过反馈页联系我们。',
    refundCta: '打开客户门户',
    refundCtaFallback: '打开反馈页',
    diffTitle: '取消 vs 退款——区别是什么？',
    diffBody: '取消订阅停止未来续费——保留 Pro 权限直到本计费周期结束。退款拿回钱并立即吊销 Pro 权限。',
    contactTitle: '需要帮助？',
    contactBody: '打开反馈页给我们发送消息。',
    contactCta: '打开反馈页',
  },
  terms: {
    title: '服务条款',
    effective: '生效日期：{date}',
    acceptance: {
      title: '条款接受',
      body: '访问或使用 DumpDeck（"服务"）即表示你同意受这些服务条款约束。如不同意，请不要使用本服务。',
    },
    serviceDescription: {
      title: '服务说明',
      body: 'DumpDeck 是一款基于浏览器的 JVM 诊断工具，在浏览器本地分析线程 Dump 和 GC 日志。所有上传的文件内容都留在浏览器内，除非你主动通过反馈表单提交。服务包括 Free 和 Pro 两个版本，功能集不同。',
    },
    userResponsibilities: {
      title: '用户责任',
      '1': '你仅在合法目的下使用本服务，遵守所有适用法律。',
      '2': '你不会反向工程、反编译或提取本服务的源代码（除使用必需外）。',
      '3': '你不会分享、转售或转让你的 Pro license 给其他用户。每个 license 绑定单一邮箱，不可转让。',
      '4': '你不会使用自动化系统（机器人、爬虫）滥用本服务，包括绕过速率限制或反馈垃圾信息。',
    },
    proSubscription: {
      title: 'Pro 订阅与支付',
      intro: 'DumpDeck Pro 是付费版本，提供批量分析、会话保存、自定义调优规则等高级功能。',
      '1': '价格在升级弹窗里显示。我们对现有订阅者调整价格会提前 30 天通知。',
      '2': '订阅计划自动续费直到取消。你可以从 footer 的"管理订阅"链接随时取消。',
      '3': '支付由 Paddle（Merchant of Record）处理。Paddle 代我们处理税务、开票和退款。',
      '4': 'Pro 功能绑定你的 license。如果订阅被取消、退款或拒付，Pro 权限将在 24 小时内吊销。',
      '5': '订阅自动续费直到取消。可随时在客户门户取消——权限保留到本计费周期结束。',
      '6': '个人使用：你的 license 仅限个人使用。不得分享、出售或转让你的 license 给他人。',
      '7': 'License 不可转让：每个 license 绑定单一邮箱。',
    },
    license: {
      title: '使用许可',
      body: '我们授予你个人、非独家、不可转让、可撤销的使用 DumpDeck 的许可（订阅期内有效）。DumpDeck 品牌、源代码和设计归 ZH Studio 所有，受相关知识产权法保护。',
    },
    disclaimer: {
      title: '免责声明',
      body1: '本服务按"原样"和"按可用"提供，不提供任何形式的明示或暗示保证。我们不保证服务无错误、不中断，或诊断结果准确或完整。',
      body2: '本服务提供的 JVM 调优建议仅供参考，不构成专业工程咨询。你承担将任何调优建议应用于生产系统的全部风险。请在非生产环境先行测试改动。',
    },
    liability: {
      title: '责任限制',
      body: '在法律允许的最大范围内，ZH Studio 对因使用本服务而产生的任何间接、附带、特殊或后果性损害不承担责任。我们对任何因本条款引起的索赔的总责任不超过你在过去 12 个月内向我们支付的金额。',
    },
    ip: {
      title: '知识产权',
      body: 'DumpDeck 的所有知识产权（包括名称、logo、设计、源代码、文档）归 ZH Studio 所有。未经事先书面同意，你不得使用我们的商标、品牌或内容。',
    },
    termination: {
      title: '终止',
      body: '如果你违反本条款，我们可能暂停或终止你的访问。你可以随时停止使用本服务。终止后的退款资格按我们的退款政策处理。',
    },
    changes: {
      title: '条款变更',
      body: '我们可能不定期更新这些条款。重大变更将通过邮件（如果你有 Pro license）或本页面通知。变更生效后继续使用即视为接受更新后的条款。',
    },
    governingLaw: {
      title: '适用法律',
      body: '本条款受 ZH Studio 注册地法律管辖，不考虑法律冲突原则。任何争议将在该司法管辖区的法院解决。',
    },
    contactTitle: '联系方式',
  },
  privacy: {
    title: '隐私政策',
    effective: '生效日期：{date}',
    overviewTitle: '概述',
    overviewBody: 'DumpDeck 是一款基于浏览器的 JVM 诊断工具。产品围绕"隐私优先"原则构建：你的数据默认留在浏览器内。我们不运行任何处理你文件的后端。本政策说明我们处理的少量数据及其保护方式。',
    dataWeCollectTitle: '我们收集什么数据',
    dataFilesTitle: '你分析的线程 Dump 和 GC 日志：',
    dataFilesBody: '永不离开浏览器。你拖入或粘贴的文件本地解析。文件内容的任何部分都不会发送到任何服务器。',
    dataLicenseTitle: 'License 信息（仅 Pro 用户）：',
    dataLicenseBody: '激活 Pro 时，我们将你的邮箱与 Pro 状态关联。服务器存储你的邮箱和激活时间，用于后续访问校验，退款或取消时立即吊销。',
    dataFeedbackTitle: '你提交的反馈（可选）：',
    dataFeedbackBody: '提交反馈时，文本和图片会发到我们的服务器供团队查看。用于修复 bug 和改进产品。',
    dataPaymentTitle: '支付信息：',
    dataPaymentBody: '支付由 Paddle（Merchant of Record）处理。Paddle 直接收集你的姓名、邮箱和卡号——我们从不见你的完整卡号。我们通过 webhook 收到：邮箱、购买的计划、交易 ID。',
    dataWhereTitle: '数据存哪',
    dataWhereLocal: '你的文件（线程 Dump、GC 日志）—— 仅在浏览器内存。关闭 tab 即清空。',
    dataWhereKV: 'License 记录 —— 存在我们服务器。',
    dataWhereR2: '反馈截图 —— 我们保存。',
    dataWhereGH: '反馈 issue 文本 — 存为私有 issue，仅我们团队可读。',
    thirdPartiesTitle: '第三方处理者',
    tpPaddle: '处理支付、发送收据、管理订阅、退款。Paddle 的隐私政策适用于支付数据。见 paddle.com/legal/privacy。',
    tpCloudflare: '我们的托管服务商 —— 托管我们的网站、API 端点和存储。见其隐私政策。',
    tpGitHub: '将用户反馈存为私有仓库中的私有 issue。仅仓库所有者可读。见 github.com/site/privacy。',
    tpFooter: '每个处理者受自身隐私承诺约束。我们仅分享他们履行功能所严格必需的信息。',
    retentionTitle: '数据保留',
    retentionLocal: '浏览器数据：留在你的浏览器直到你清除。你完全控制——我们无法远程删除。',
    retentionKV: 'License：订阅有效期内保留；退款或取消时立即删除。',
    retentionR2: '反馈图片：保留直到你要求删除。邮件客服可删特定反馈。',
    rightsTitle: '你的权利',
    rightsBody: '你有权访问、删除或导出你的数据。浏览器本地数据可通过浏览器设置清除。服务器数据请邮件我们。',
    rightsAccess: '访问：问我们持有哪些关于你的数据',
    rightsDelete: '删除：请求删除你的 license 记录、反馈图片、反馈 issue',
    rightsExport: '导出：收到我们持有的关于你的任何数据副本',
    rightsCta: '邮件客服行使这些权利',
    cookiesTitle: 'Cookie',
    cookiesBody: '我们不使用行为追踪 cookie 或跨站追踪器。可能设置第一方 cookie 用于必要功能（如会话状态）。我们绝不向第三方出售或共享 cookie 数据。',
    analyticsTitle: '分析',
    analyticsBody: '我们可能使用隐私友好的分析服务（如 Plausible）统计匿名访客、了解功能使用情况。无跨站追踪、无行为画像、不卖数据。Pro 用户不加载分析脚本。',
    selfProofTitle: '自证：如何验证',
    intro: '你的 thread dump 和 GC log 永远不离开浏览器。所有解析在本地完成。',
    verify: '通过 F12 验证',
    verifySteps: [
      '打开 DevTools（F12 或 Cmd+Opt+I）。',
      '切换到 Network 标签页。',
      '拖入 thread dump 或粘贴 GC log。',
      '观察 Network 标签页 — 没有包含你 dump 内容的请求。只有静态资源，可选的匿名分析 ping。',
    ],
    swTitle: 'Service Worker (PWA)',
    swDesc: 'Service worker 只缓存静态资源（应用 bundle、字体、图标）。它不会拦截或读取用户文件。',
    dontTrack: '我们不追踪你',
    dontTrackDesc: '我们不跨会话追踪你的身份。我们不卖你的数据。你的 dump 内容留在浏览器——这是核心承诺，可通过 F12 验证。',
    source: '源代码',
    sourceDesc: "解析核心是一个独立的包，在后台运行。完整源码在此仓库中。",
    contactTitle: '联系方式',
  },
  export: {
    markdown: 'Markdown (.md)',
    json: 'JSON (.json)',
    pdf: 'PDF（通过打印）',
  },
  lang: {
    en: 'EN',
    zh: '中文',
  },
};
